import { Box, Icon } from '@chakra-ui/react'
import { BiCamera } from 'react-icons/bi'
import { BsGearFill } from 'react-icons/bs'

const EditProfileIcon = () => (
  <Box position="relative">
    <BiCamera />
    <>
      <Icon position="absolute" top="-2px" right="-2px" width="75%" height="75%" color="black" asChild>
        <BsGearFill />
      </Icon>
      <Icon position="absolute" top="-2px" right="-2px" width="65%" height="65%" color="white" asChild>
        <BsGearFill />
      </Icon>
    </>
  </Box>
)

export default EditProfileIcon
